module.exports = "/assets/data/abadab5fe624106c64a2a7e7487b474b-W1K.data.json";